import ApiService from './ApiService';

export default class StudyFieldsService {
  static fetchAll() {
    return ApiService.get('study-fields');
  }
}
